import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { useLocation } from 'react-router-dom';
import WabliAppBar from '../WabliAppbar/WabliAppBar';
import AuthenticationBreadcrumb from './AuthenticationBreadcrumb';
import apiService from '../../services/apiService';
import { Card } from './AuthenticationCard';

// This component is responsible to render content in about_page

const DeployPage = () => {
  const location = useLocation();
  const [selectedProject, setSelectedProject] = useState(location.state.selectedProject);
  const [projectName, setProjectName] = useState('');
  const [projectId, setProjectId] = useState('');
  const [deployConfig, setDeployConfig] = useState();
  const [arrayOfConfigs, setArrayOfConfigs] = useState([]);

  useEffect(() => {
    //  escapes when there is no selection
    if (selectedProject === -1) return;
    const { name, _id } = JSON.parse(localStorage.getItem('data'))[selectedProject];
    setProjectId(_id);
    setProjectName(name);
    apiService
      .readProject(_id, { field: 'deployConfiguration' })
      .then(({ data }) => {
        setDeployConfig(
          data.deployConfiguration || {
            name: '',
            serverName: '',
            url: '',
            port: ''
          }
        );
      })
      .catch((error) => {
        throw error;
      });
  }, [selectedProject]);

  useEffect(() => {
    apiService
      .getUserField('deployConfiguration')
      .then(({ data }) => Promise.all(data.map((configId) => apiService.getDeployConfig(configId))))
      .then((responseArray) => {
        if (
          deployConfig?.name &&
          !responseArray.find((config) => config.name === deployConfig.name)
        )
          setArrayOfConfigs(responseArray.concat(deployConfig));
        else setArrayOfConfigs(responseArray);
      })
      .catch((error) => {
        throw error;
      });

    // apiService.getAllDeployConfigs().then((responseArray) => setArrayOfConfigs(responseArray));
  }, [selectedProject, deployConfig]);

  return (
    <div style={{ height: '100%', overflow: 'scroll' }}>
      <div style={{ width: '100%', zIndex: '1000' }}>
        <WabliAppBar /> {/* Wabli app bar */}
        <AuthenticationBreadcrumb
          selectedProject={selectedProject}
          setSelectedProject={setSelectedProject}
        />{' '}
        {/* Deploy breadcrumb */}
      </div>
      {/**/}
      {deployConfig && arrayOfConfigs && (
        <Body
          name={projectName}
          deployData={deployConfig}
          arrayOfConfigs={arrayOfConfigs}
          selectedProject={selectedProject}
          projectId={projectId}
        />
      )}
    </div>
  );
};
const Body = ({ name, deployData, arrayOfConfigs, selectedProject, projectId }) => (
  <div className={clsx('generalMarg', 'spacingTop')} style={{ height: '75%' }}>
    <h2 style={{ fontWeight: '500', fontSize: '1.5rem' }}>{name}</h2>
    <div style={{ display: 'flex', height: '75%' }}>
      <Card
        deploymentData={deployData}
        title="Authentication Card"
        tooltipMessage="This card shows the authentication summary"
        arrayOfConfigs={arrayOfConfigs}
        projectId={projectId}
        selectedProject={selectedProject}
      />
    </div>
  </div>
);
export default DeployPage;
